import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Coins, Video } from "lucide-react";
import { COACH_ARGS } from "@/content/landing";
import Reveal from "./Reveal";

const ICONS = [Coins, CalendarDays, Video];

export default function ForCoaches() {
  return (
    <section className="landing-section for-coaches" id="coachs">
      <Reveal className="for-coaches-copy">
        <span className="eyebrow">{COACH_ARGS.eyebrow}</span>
        <h2>{COACH_ARGS.title}</h2>
        <p>{COACH_ARGS.lead}</p>
        <Link to={COACH_ARGS.cta.to} className="button button-dark" data-testid="landing-coach-cta">{COACH_ARGS.cta.label}<ArrowRight size={14} /></Link>
      </Reveal>
      <div className="for-coaches-grid">
        {COACH_ARGS.items.map((it, i) => { const Icon = ICONS[i]; return (
          <Reveal key={it.title} delay={i * 0.07} className="feature">
            <span className="feature-icon"><Icon size={15} /></span>
            <h3>{it.title}</h3>
            <p>{it.text}</p>
          </Reveal>
        ); })}
      </div>
    </section>
  );
}
